import { combineReducers } from "redux";
import auth from "./reducers/auth";
import app from "./reducers/app";
import user from "./reducers/user";
import dashboard from "./reducers/dashboard";
import registration from "./reducers/registration";
import filter from "./reducers/filter";

export default combineReducers({ auth, app, user, dashboard, registration, filter });
